export enum RepliersListingCondoExposure {
  'N' = 'N',
  'S' = 'S',
  'E' = 'E',
  'W' = 'W',
  'NE' = 'Ne',
  'NW' = 'Nw',
  'SE' = 'Se',
  'SW' = 'Sw',
  'EW' = 'Ew',
  'NS' = 'Ns',
}
